import React from 'react';
import { Typography } from 'antd';
import './RichTextEditor.css'; // Reuse the same CSS file for consistent styling

const { Text } = Typography;

/**
 * RichTextDisplay Component
 * 
 * Displays rich text content with the same styling as RichTextEditor
 * to ensure consistency between view and edit modes.
 * 
 * @param {Object} props
 * @param {string} props.content - HTML content to display
 * @param {Object} props.style - Additional inline styles
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.showEmpty - Whether to show empty state text (default: true)
 * @param {string} props.emptyText - Text to show when content is empty (default: "No content")
 */
const RichTextDisplay = ({ 
  content, 
  style = {}, 
  className = '', 
  showEmpty = true, 
  emptyText = "No content" 
}) => {
  // Check if content is empty or only contains empty HTML tags
  const isEmpty = !content || 
    content.trim() === '' || 
    content.replace(/<p><\/p>/g, '').replace(/<br\s*\/?>/g, '').trim() === '';

  // If content is empty and showEmpty is true, display empty state
  if (isEmpty && showEmpty) {
    return <Text type="secondary">{emptyText}</Text>;
  }

  // If content is empty and showEmpty is false, return null
  if (isEmpty && !showEmpty) {
    return null;
  }

  // Clean the content by removing empty paragraphs
  const cleanContent = content
    .replace(/<p><\/p>/g, '') // Remove empty paragraphs
    .trim();

  return (
    <div
      className={`rich-text-display prosemirror-content ${className}`}
      style={{
        lineHeight: '1.5715',
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.85)',
        ...style
      }}
      dangerouslySetInnerHTML={{ __html: cleanContent }}
    />
  );
};

export default RichTextDisplay;
